
import { computed, defineComponent, ref } from 'vue';
import { useStore } from "@/store";
import PageLoading from '@/components/PageLoading.vue';

export default defineComponent({
  name: 'BiOpportunityPlanB',
  components: {
    PageLoading: PageLoading,
  },
  setup() {
    const isLoading = ref(true);
    const store = useStore();
    const sectionMain = ref<HTMLElement | null>(null);
    const opportunityFromBiURL = computed(() => store.getters.selectedBiOpportunityURL);

    const handleIframeLoad = () => {
      setTimeout(() => {
        isLoading.value = false;
      }, 4100);
    };

    const goBack = () => {
      window.history.back();
    };

    return {
      isLoading,
      sectionMain,
      handleIframeLoad,
      opportunityFromBiURL,
      goBack,
    };
  }
});
